const LOCATION_LIST = "locationList";

export const getLocalLocationList = () => {
  return localStorage.getItem(LOCATION_LIST)
    ? (JSON.parse(localStorage.getItem(LOCATION_LIST) as string) as string[])
    : [];
};
export const setLocalLocationList = (locationList: string[]) => {
  return localStorage.setItem(LOCATION_LIST, JSON.stringify(locationList));
};
export const deleteLocalLocationList = () =>
  localStorage.removeItem(LOCATION_LIST);
